// Or from '@reduxjs/toolkit/query' if not using the auto-generated hooks
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const BASE_URL = process.env.SERVER_URL;

// initialize an empty api service that we'll inject endpoints into later as needed
export const emptySplitApi = createApi({
    reducerPath: 'fullApi',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL,
        credentials: 'include',
        prepareHeaders: (headers) => {
            headers.set('Accept', 'application/json');
            headers.set('X-Referer', document.location.href);
            return headers;
        },
        paramsSerializer: (params) => {
            const searchParams = new URLSearchParams();

            Object.keys(params).forEach((key) => {
                const value = params[key];

                if (Array.isArray(value) && value.length) {
                    value.forEach((item) => searchParams.append(`${key}[]`, item));
                } else {
                    if (value) {
                        searchParams.append(key, value);
                    }
                }
            });

            return searchParams.toString();
        },
    }),
    tagTypes: [],
    endpoints: () => ({}),
});
